<script lang="ts">
  import { onMount } from "svelte";
  import * as PDFJS from "pdfjs-dist";
  // @ts-ignore
  import { pdfjsWorker } from "pdfjs-dist/build/pdf.worker.entry";
  import type { RenderParameters } from "pdfjs-dist/types/src/display/api";
  import ZoomableContainer from "./ZoomableContainer.svelte";

  const PADDING = 164;

  let container: HTMLDivElement;
  let pdfCanvas: HTMLCanvasElement;
  let pdf: PDFJS.PDFDocumentProxy;
  let renderContext: RenderParameters;
  let zoom: boolean = false;
  let zoomClick: MouseEvent;
  let contextMenuVisible: boolean = false;
  let contextMenuX = 0;
  let contextMenuY = 0;

  export let pageCount: number;
  export let url: string;
  export let page: number = 1;
  export let scale: number = 2;

  $: {
    loadPage(page);
  }

  async function loadPage(pageNumber: number) {
    if (!pdf) return;
    const page = await pdf.getPage(pageNumber);

    await page.render(renderContext);
  }

  onMount(async () => {
    const loadingTask = PDFJS.getDocument(url);
    pdf = await loadingTask.promise;

    const page = await pdf.getPage(1);
    pageCount = pdf.numPages;

    const viewport = page.getViewport({ scale });

    const context: CanvasRenderingContext2D | null = pdfCanvas.getContext("2d");

    if (!context) {
      throw new Error("Could not get canvas context");
    }

    pdfCanvas.width = viewport.width;
    pdfCanvas.height = viewport.height;

    renderContext = {
      canvasContext: context,
      viewport: viewport,
    };

    await page.render(renderContext);
  });

  function toggleZoom(event: MouseEvent) {
    if (contextMenuVisible) {
      hideContextMenu();
      return;
    }
    zoomClick = event;
    zoom = !zoom;
  }

  function handleContextMenu(event: MouseEvent) {
    if (zoom) {
      return;
    }

    contextMenuX = event.offsetX;
    contextMenuY = event.offsetY;
    contextMenuVisible = true;
    event.preventDefault();
  }

  function hideContextMenu() {
    contextMenuVisible = false;
  }
</script>

<ZoomableContainer {zoom} {zoomClick}>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    class="container"
    bind:this={container}
    on:click={toggleZoom}
    on:contextmenu={handleContextMenu}
  >
    <canvas id="pdf-canvas" bind:this={pdfCanvas} />
    {#if contextMenuVisible}
      <div class="context-menu" style="left: {contextMenuX}px; top: {contextMenuY}px;">
        <div class="context-menu-item" on:click={() => window.open(url, "_blank")}>
          open in new tab
        </div>
      </div>
    {/if}
  </div>
</ZoomableContainer>

<style>
  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
  }

  .context-menu {
    position: absolute;
    background-color: var(--rk-divider-4);
    border-radius: var(--rk-rounding-m);
    overflow: hidden;
    z-index: 1000;
  }

  .context-menu-item {
    cursor: pointer;
    padding: 8px 16px;
    color: var(--rekki-light);
  }
  .context-menu-item:hover {
    background-color: var(--rk-text-dark);
  }
</style>
